import { Box } from '@atgfr8/atg-ui-tailwind';
import { Tab, TabsComponent } from '@components';
import { ediConfigurationStore } from '@store/customers/customerDetails';
import { Match, Switch, createSignal } from 'solid-js';

import { RulesTabContent } from './components';

const Rules = () => {
  const [activeTab, setActiveTab] = createSignal(0);

  const tabs = [
    'HANDLE TENDER',
    'INVOICE',
    'LOAD CREATE',
    'STATUS UPDATE',
    'RESPONSE',
  ];

  return (
    <Box class="mt-4 ">
      <TabsComponent
        activeStyling=" border-b-[#123B50]"
        tabs={tabs.map((item, i) => (
          <Tab
            customStyle={`${
              activeTab() === i
                ? 'text-[#123B50]!'
                : 'text-[#000000]! text-opacity-[60%]!'
            }`}
          >
            {item}
          </Tab>
        ))}
        activeTab={activeTab()}
        onTabClick={setActiveTab}
      />
      <div class="py-2"></div>
      <Switch>
        <Match when={activeTab() === 0}>
          <RulesTabContent
            initialData={{
              A: ediConfigurationStore.ediData.assignedloadTenderRuleList,
              B: ediConfigurationStore.ediData.loadTenderRuleList,
            }}
            keyToUpdate="assignedloadTenderRuleList"
            key2="loadTenderRuleList"
          />
        </Match>
        <Match when={activeTab() === 1}>
          <RulesTabContent
            initialData={{
              A: ediConfigurationStore.ediData.assignedInvoiceRuleList,
              B: ediConfigurationStore.ediData.invoiceRuleList,
            }}
            keyToUpdate="assignedInvoiceRuleList"
            key2="invoiceRuleList"
          />
        </Match>
        <Match when={activeTab() === 2}>
          <RulesTabContent
            initialData={{
              A: ediConfigurationStore.ediData.assignedLoadCreateRuleList,
              B: ediConfigurationStore.ediData.loadCreateRuleList,
            }}
            keyToUpdate="assignedLoadCreateRuleList"
            key2="loadCreateRuleList"
          />
        </Match>
        <Match when={activeTab() === 3}>
          <RulesTabContent
            initialData={{
              A: ediConfigurationStore.ediData.assignedStatusUpdateRuleList,
              B: ediConfigurationStore.ediData.statusUpdateRuleList,
            }}
            keyToUpdate="assignedStatusUpdateRuleList"
            key2="statusUpdateRuleList"
          />
        </Match>
        <Match when={activeTab() == 4}>
          <RulesTabContent
            initialData={{
              A: ediConfigurationStore.ediData.assignedResponseRuleList,
              B: ediConfigurationStore.ediData.responseRuleList,
            }}
            keyToUpdate="assignedResponseRuleList"
            key2="responseRuleList"
          />
        </Match>
      </Switch>
    </Box>
  );
};

export default Rules;
